import { Card, Col, Container, Row } from 'react-bootstrap';
import './familyDetailsPanelStyle.css';
import _ from 'lodash';

const FamilyDetailsPanel = ({ familyDetails }) => {
  const maritalStatus = _.get(familyDetails, 'maritalStatus');
  const hasChildren = _.get(familyDetails, 'hasChildren');

  if (!maritalStatus && !hasChildren) {
    return (
      <Card className="familyDetailsPanel mt-2">
        <Card.Body>
          <Container>
            <h3>Family Details</h3>
            <Row>
              <Col>
                {/* <p className="no-family-details-message">No family details available</p> */}
              </Col>
            </Row>
          </Container>
        </Card.Body>
      </Card>
    );
  }

  return (
    <Card className="familyDetailsPanel mt-2">
      <Card.Body>
        <Container>
          <h3>Family Details</h3>
          {maritalStatus === 'MARRIED' &&
            _.get(familyDetails, 'spouseCurrentOccupation') &&
            _.get(familyDetails, 'spouseCurrentOccupation') !== 'NOT_APPLICABLE' && (
              <Row>
                <Col>
                  <span className="label">Spouse's Role</span>
                </Col>
                <Col>
                  <span className="label professionValue">{_.get(familyDetails, 'spouseCurrentOccupation')}</span>
                </Col>
              </Row>
            )}
          {hasChildren === 'YES' && (
            <Row>
              <Col>
                <span className="label">No. of Children</span>
              </Col>
              <Col>
                <span className="label professionValue">{_.get(familyDetails, 'noOfChildren')}</span>
              </Col>
            </Row>
          )}
        </Container>
      </Card.Body>
    </Card>
  );
};

export default FamilyDetailsPanel;